// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"f36784af","592":"11c2f0c7","964":"b3f181dc"}[chunkId] + ".chunk.js";
};